import { RoomSearchInfo } from '@/__generated';
import { AppUrls } from '@/urls';
import React from 'react';

type Props = {
  bookingRefNumber: string;
  rooms: RoomSearchInfo[];
};

export default function SamePaxAndNextBookingButton({ bookingRefNumber, rooms }: Props) {
  const url = React.useMemo(() => {
    return AppUrls.__createSamePaxAndNextBookingUrl(bookingRefNumber, rooms);
  }, [bookingRefNumber, rooms]);
  return (
    <a className="button px-20 py-15 -dark-1 bg-blue-1 text-white" href={url} target="_blank">
      Add hotel for the same guest
      <i className="icon-arrow-top-right ml-15" />
    </a>
  );
}
